import './base/';
import './sliders/sliders';
import './components/wrapper';
import './components/popup-hotspot';
import './hover-events';
import './utils/quantity';
import './utils/selectric';
import './utils/tabs';
import './utils/accordions';
import './modules/parallax';
import './modules/google-map';
import './modules/autoplay-video';
import './modules/youtube-video-api';
import './modules/youtube-video';
import './modules/vimeo-video-api';
import './modules/sticky-content';
import './modules/scroll-control';
import './modules/random-background';
import './cart/cart';
import './cart/recommendations';
import './cart/ajax-actions';
import './product/product-options';
import './product/recommendations';
import './account/retail-order';
import './product/find-store';

import { calcBackgroundVideoSize } from './modules/background-videos-size';
import { clickEvent } from './click-events';
import { falseSelect } from './click-events';
import { mobileMenuExpand } from './click-events';
import { mobileMenuDropdown } from './click-events';

import { stickyHeader } from './scroll-events';

// Your code goes here...
// jQuery.ready is no longer needed

stickyHeader($('.header'), 'fixed');

mobileMenuDropdown($('.nav-mobile > ul > li.menu__item--has-dropdown > a'), '.menu__item', 'open');

mobileMenuExpand($('.js-menu'), $('.header__mobile'), [$(this), $('.header'), $('.link-cart'), $('.js-menu')], 'open');

falseSelect($('.custom-select h6'), '.custom-select', 'open');

clickEvent($('.announcement-bar__close'), $('.announcement-bar'), 'open');
